import { render } from "./MainStage.vue?vue&type=template&id=97486536&scoped=true"
import script from "./MainStage.vue?vue&type=script&lang=js"
export * from "./MainStage.vue?vue&type=script&lang=js"

import "./MainStage.vue?vue&type=style&index=0&id=97486536&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97486536"]])

export default __exports__